/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The GoalstemplatesidGoalTemplateReminders model module.
 * @module model/GoalstemplatesidGoalTemplateReminders
 * @version v0.3
 */
export default class GoalstemplatesidGoalTemplateReminders {
  /**
   * Constructs a new <code>GoalstemplatesidGoalTemplateReminders</code>.
   * @alias module:model/GoalstemplatesidGoalTemplateReminders
   * @class
   * @param days {Number} Non-negative whole days relative to the anchor. Stored as 0 when relation is on.
   * @param relation {module:model/GoalstemplatesidGoalTemplateReminders.RelationEnum} Whether the reminder occurs before, after, or on the anchor date
   */
  constructor(days, relation) {
    this.days = days;
    this.relation = relation;
  }

  /**
   * Constructs a <code>GoalstemplatesidGoalTemplateReminders</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/GoalstemplatesidGoalTemplateReminders} obj Optional instance to populate.
   * @return {module:model/GoalstemplatesidGoalTemplateReminders} The populated <code>GoalstemplatesidGoalTemplateReminders</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new GoalstemplatesidGoalTemplateReminders();
      if (data.hasOwnProperty('days'))
        obj.days = ApiClient.convertToType(data['days'], 'Number');
      if (data.hasOwnProperty('relation'))
        obj.relation = ApiClient.convertToType(data['relation'], 'String');
      if (data.hasOwnProperty('anchor'))
        obj.anchor = ApiClient.convertToType(data['anchor'], 'String');
    }
    return obj;
  }
}

/**
 * Non-negative whole days relative to the anchor. Stored as 0 when relation is on.
 * @member {Number} days
 */
GoalstemplatesidGoalTemplateReminders.prototype.days = undefined;

/**
 * Allowed values for the <code>relation</code> property.
 * @enum {String}
 * @readonly
 */
GoalstemplatesidGoalTemplateReminders.RelationEnum = {
  /**
   * value: "before"
   * @const
   */
  before: "before",

  /**
   * value: "after"
   * @const
   */
  after: "after",

  /**
   * value: "on"
   * @const
   */
  on: "on"
};
/**
 * Whether the reminder occurs before, after, or on the anchor date
 * @member {module:model/GoalstemplatesidGoalTemplateReminders.RelationEnum} relation
 */
GoalstemplatesidGoalTemplateReminders.prototype.relation = undefined;

/**
 * Allowed values for the <code>anchor</code> property.
 * @enum {String}
 * @readonly
 */
GoalstemplatesidGoalTemplateReminders.AnchorEnum = {
  /**
   * value: "surgery"
   * @const
   */
  surgery: "surgery",

  /**
   * value: "referral"
   * @const
   */
  referral: "referral"
};
/**
 * Referral uses referral_date, falling back to the creation date in US Central time.
 * @member {module:model/GoalstemplatesidGoalTemplateReminders.AnchorEnum} anchor
 * @default 'surgery'
 */
GoalstemplatesidGoalTemplateReminders.prototype.anchor = 'surgery';
